// teachers/order-list
import React from 'react';
// import View from 'src/pages/teachers/orders/list';
// import { PaginationProvider } from 'src/contexts/pagination-context';
// import { useItemsSearch, useItemsIds, repairApi } from 'src/api/repairs/vm-view';

// const Page = () => {
//   const search = useItemsSearch();
//   const store = repairApi.getMyItems(search.state);
//   const ids = useItemsIds(store.items);
  
//   return (
//       <PaginationProvider endpoint={store.endpoint} keyword={store.query}>
//         <View dataSearch={search} dataStore={store} dataIds={ids} />
//       </PaginationProvider>
//   );
// };

import View from 'src/pages/coming-soon';

const Page = () => {
  return <View message="Lịch dạy và ca trực" />;
};

export default Page;
